export function Services() {
  return (
    <section id="services" className="py-24 bg-white">
    </section>
  );
}